import React from "react";
import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaMapMarkerAlt
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import webTeckWhiteLogo from "../../../../images/logo/onTrack-pink.png";
import upWork from "./images/upButton.png";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-custom-dark-blue text-white py-12">
      <div className="mx-auto ">
        <div className="container mx-auto px-4 ">
          {/* Contact Info Section */}
          <div className="flex flex-wrap justify-between gap-8 py-[80px]">
            {/* Address */}
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 bg-custom-gradient rounded-full items-center flex justify-center">
                <FaMapMarkerAlt className="text-white" />
              </div>
              <div>
                <h4 className="font-bold text-light-gray">ADDRESS</h4>
                <p>
                  15300 Croydon Dr Suite 300,
                  <br />
                  Surrey, BC V3Z 0Z5
                </p>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 bg-custom-gradient rounded-full items-center flex justify-center">
                <FaEnvelope className="text-white" />
              </div>
              <div>
                <h4 className="font-bold text-light-gray">EMAIL</h4>
                <p>info@ontrackcareers.ai</p>
              </div>
            </div>

            {/* Phone */}
            {/* <div className="flex items-center gap-4">
              <div className="w-14 h-14 bg-custom-gradient rounded-full items-center flex justify-center">
                <FaPhoneAlt className="text-white" />
              </div>
              <div>
                <h4 className="font-bold text-light-gray">CALL</h4>
                <p>
                  +1 (778) 246 5849
                  <br />
                  +1 (778) 837 3282
                </p>
              </div>
            </div> */}
          </div>

          {/* Company Info and Navigation */}
          <div className="bg-custom-gradient rounded-[40px] mb-10 pt-20">
            <div className="flex flex-col justify-between items-center gap-10">
              <div className="px-14 py-4 w-full">
                <div className="flex w-full flex-col md:flex-row  items-center justify-between gap-2">
                  {/* Logo */}
                  <div className="flex items-center mb-4 md:mb-0 ">
                    <h1 className="text-3xl font-bold">
                      <img
                        className="h-20 w-auto"
                        src={webTeckWhiteLogo}
                        alt="webTeckWhiteLogo"
                      />
                    </h1>
                  </div>
                  {/* About Text */}
                  <div className="text-light-gray text-lg max-w-full mb-4 md:mb-0 w-[613px]">
                    We empower professionals to thrive in an AI-driven world
                    with in-depth assessments, personalized career resources,
                    and a supportive community, helping individuals navigate
                    AI's impact and build resilient, future-ready career paths
                  </div>
                </div>
              </div>

              <div className="flex flex-col md:flex-row  items-center justify-center gap-2 md:justify-between w-full bg-light-pink rounded-[40px] px-16 py-4">
                {/* <div className="md:flex grid grid-cols-2 gap-8 mb-4 md:mb-0 text-sm font-semibold">
                  <a
                    href="#about"
                    className="hover:text-white text-xs md:text-base transition hover:underline"
                  >
                    About Us
                  </a>
                  <a
                    href="#blog"
                    className="hover:text-white text-xs md:text-base transition hover:underline"
                  >
                    Career Blog
                  </a>
                  <a
                    href="#impact"
                    className="hover:text-white text-xs md:text-base transition hover:underline"
                  >
                    AI Job Impact Assessment
                  </a>
                  <a
                    href="#quiz"
                    className="hover:text-white text-xs md:text-base transition hover:underline"
                  >
                    AI Literacy Quiz
                  </a>
                </div> */}
                {/* Social Links */}
                <div className="flex items-center gap-4">
                  <a
                    href="https://www.facebook.com/people/OnTrack-Careers/61575575944364/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebookF className="text-2xl cursor-pointer hover:text-blue-500 transition border border-white rounded-full p-1" />
                  </a>
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <FaXTwitter className="text-2xl cursor-pointer hover:text-blue-500 transition border border-white rounded-full p-1" />
                  </a>
                  <a  href="https://www.instagram.com/ontrackcareers?igsh=a2E2Z3BsZW13eXcz&utm_source=qr"
                    target="_blank"
                    rel="noopener noreferrer">
                    <FaInstagram className="text-2xl cursor-pointer hover:text-blue-500 transition border border-white rounded-full p-1" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/ontrack-careers"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedinIn className="text-2xl cursor-pointer hover:text-blue-500 transition border border-white rounded-full p-1" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Scroll to Top Button */}
        <button
          className="flex justify-end items-end w-full pr-4"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <img src={upWork} alt="upWork" />
        </button>
        <div className="pb-4">
          <hr
            style={{
              backgroundColor: "#2c2e34", // For setting the color of the line
              border: "none", // Removes default border styling
              height: "2px", // Set thickness of the line
              width: "100%",
            }}
          />
        </div>
        {/* Footer Links and Copyright */}
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <div>&copy; {currentYear} OnTrack Careers. All Rights Reserved.</div>
          <div className="mt-4 md:mt-0">
            <Link to={"/termsOfService"} className="hover:text-white transition">
              Terms of Service
            </Link>{" "}
            |{" "}
            <Link to={"/privacyPolicy"} className="hover:text-white transition">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
